export default "__VITE_ASSET__B7vgmScZ__"